import React from 'react';
import { topTestimonials } from '../data/content';
import { TestimonialCard } from './TestimonialCard';
export function Testimonials() {
  return <section aria-label="Testimonios destacados" className="w-full bg-cream py-12 sm:py-14" data-id="element-253" data-mp="3kr5t64yb13k8">
      <div className="mx-auto grid max-w-6xl gap-5 px-5 md:grid-cols-3" data-id="element-254" data-mp="3fxumq4xemosu">
        {topTestimonials.map(testimonial => <TestimonialCard key={testimonial.name + testimonial.meta} testimonial={testimonial} data-id="element-255" data-mp="3ayqb77n0cezc" />)}
      </div>
    </section>;
}